<!--
vData:传入数据
cd(type,eData,iscb): 事件回调
type:message/invite/details/collect/live ==> 消息/邀请/详情/收藏/直播
eData:{}返回的数据
iscb:是否触发回调 默认是true

浏览列表 展商卡片
-->
<template>
  <div class="v-exhibitor-card" v-if="vData" @click.stop="details(vData)">
    <div class="actor-card-top" v-if="$store.state.config.hideElement">
      <div class="v-collect pointer" @click.stop="collect(vData)">
        <template v-if="showType === 'find' || showType === 'footprint'">
          <i class="iconfont theme-icon-primary-color"
            :class="{ 'iconshoucang-xuanzhong': vData['collected'], iconshoucang: !vData['collected'] }"></i>
          <span>{{ vData['collected'] ? $t('collect[1]') : $t('collect[0]') }}</span>
        </template>
        <template v-if="showType === 'collection'">
          <i class="iconfont theme-icon-primary-color iconshoucang-xuanzhong"></i>
          <span>{{ $t('collect[1]') }}</span>
        </template>
      </div>
      <span class="v-follow-num" v-if="vData['uniqueVisitor'] || vData['actorPv']"><i
          class="el-icon-view theme-icon-primary-color"></i>{{ vData['uniqueVisitor'] || vData['actorPv'] }}</span>
    </div>
    <div class="v-exhibitor-header flex-start">
      <div class="img-box">
        <el-avatar shape="square" :size="60" fit="contain"
          :src="vData['logoImage'] || vData['atrLogo'] || defImage('product')" style="border-radius: 0px"></el-avatar>
      </div>
      <div class="v-exhibitor-info">
        <div class="flex">
          <div class="product-hot hot2" v-if="vData['recommend']">{{ $t('finds.preferredExhibits') }}</div>
          <span class="v-company-name">{{ vData['name'] || vData['exhibitorName'] || vData['atrName'] }}</span>
        </div>
        <div class="flex-start v-exhibitor-info2">
          <div class="label-text">
            {{ vData['exhibitionBoothPart'] || vData['pavilionCode'] }} {{ vData['exhibitionBoothNumber'] ||
            vData['bthCode'] }}
          </div>
          <div class="pointer" style="line-height: 20px;" v-if="vData['liveState']" @click.stop="live(vData)">
            <span class="iconfont iconzhibo theme-color"></span>
            <span class="theme-color v-live-text">{{ liveStatusText(vData.live) }}</span>
          </div>
        </div>
        <div class="head-tag-list">
          <template v-for="item in vData['questionList']">
            <template v-if="tag3.indexOf(item.id) > -1">
              <span class="theme-label no-radius" v-for="qItem in item['answerList']" :key="qItem.id">{{
                language == 'zh' ? qItem.aliasName : qItem.aliasEnName
                }}</span>
            </template>
          </template>
        </div>
        <!-- <div class="flex text-center v-exhibitor-info3">
          <div class="flex-start">
            <div>
              <p class="num theme-icon-primary-color">{{ (vData['attendTimes'] == null || vData['attendTimes'] == '') ? '--' : vData['attendTimes'] }}</p>
              <p class="margin-t-3">{{ $t('joinExhibitorNum') }}</p>
            </div>
            <div class="v-item">
              <p class="num theme-icon-primary-color">{{ (vData['registeredCapital'] == null || vData['registeredCapital'] == '') ? '--' : vData['registeredCapital'] }}</p>
              <p class="margin-t-3">{{ $t('registeredCapital') }}</p>
            </div>
            <div>
              <p class="num theme-icon-primary-color">{{ (vData['companyScale'] == null || vData['companyScale'] == '') ? '--' : vData['companyScale'] }}</p>
              <p class="margin-t-3">{{ $t('scaleOfCompany') }}</p>
            </div>
          </div> 
        </div> -->
      </div>
    </div>

    <div class="v-exhibitor-body text-left">
      <v-swiper :option="option" :showBtn="false"></v-swiper>
      <div class="v-tag-list">
        <template v-for="item in vData['questionList']">
          <template>
            <span class="theme-label" v-for="qItem in item['answerList']" :key="qItem.id">{{
              language == 'zh' ? qItem.aliasName : qItem.aliasEnName
              }}</span>
          </template>
        </template>
      </div>
    </div>
    <div class="v-exhibitor-footer flex-end font-size-14 align-center">
      <!-- <template v-if="$store.state.config.hideElement">
        <div class="pointer" @click.stop="msg(vData)">
          <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
          <span>{{ $t('message') }}</span>
        </div>
        <div class="pointer disabled" v-if="vData['invite']" @click.stop>
          <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
          <span>{{ $t('finds.invited') }}</span>
        </div>
        <div class="pointer" @click.stop="invite(vData)" v-else>
          <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
          <span>{{ $t('invite') }}</span>
        </div>
      </template> -->
      <div class="pointer" @click.stop="details(vData)">
        <span class="el-icon-tickets theme-icon-primary-color"></span>
        <span>{{ $t('details') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vSwiper from '@/components/vSwiper'

export default {
  components: {
    vSwiper
  },
  props: {
    /* *
     * 组件显示的页面位置，
     * 找展商(find)/浏览记录(footprint)/我的收藏(collection)
     * */
    showType: {
      type: String,
      default: 'find'
    },
    index: {
      type: Number,
      default: 0
    },
    vData: {
      type: [Object],
      default: () => {}
    },
    // 一屏显示几张图片
    slides: {
      type: Number,
      default: 4
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  data() {
    return {
      option: {
        imgW: '95px',
        imgH: '95px',
        list: [],
        slidesPerView: this.slides
      },
      //产品材质
      tag1: [],
      //贵司的产品类别
      tag2: [],
      tag3: []
    }
  },
  watch: {
    'vData.id': function() {
      this.pageInit()
    }
  },
  mounted() {
    this.tag1 = ['2007baoliqiuji', '20071baoliqiuji']
    this.tag2 = ['2003baoliqiuji', '20031baoliqiuji']
    this.tag3 = ['2009baoliqiuji', '20091baoliqiuji']
    this.pageInit()
  },
  methods: {
    pageInit() {
      this.option.list = []
      let _list = []
      if (this.showType === 'collection' && this.vData.atrImageUrl != null && this.vData.atrImageUrl != '') {
         _list = this.vData.atrImageUrl.split(',')
      }
      if (this.showType !== 'collection' && this.vData.advertsImage != null && this.vData.advertsImage != '') {
         _list = this.vData.advertsImage.split(',')
      }
      _list.forEach(element => {
        if (element) {
          this.option.list.push(element)
        }
      })
      this.option.list = this.minImageThree(this.option.list, 'product3')
    },
    //收藏
    collect(data) {
      if (this.showType === 'collection') {
        this.$emit(
          'collect',
          {
            id: data.id,
            deleted: true,
            collectionSubjectType: 'ACTOR',
            collectionSubjectId: data.actorId
          },
          this.index
        )
      } else {
        this.$emit(
          'collect',
          {
            id: data.collectionId,
            deleted: data.collected,
            collectionSubjectType: 'ACTOR',
            collectionSubjectId: data.exhibitorId
          },
          this.index,
          data
        )
      }
    },
    //邀约
    invite(data) {
      this.$emit(
        'invite',
        {
          projectId: data.projectId,
          userId: data.visitorId
        },
        this.index,
        data
      )
    },
    //消息
    msg(data) {
      this.$emit('msg', data)
    },
    //详情
    details(data) {
      this.$emit('details', data)
    },
    // 直播
    live(data) {
      this.$emit('live', data)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-exhibitor-card
  padding-top 12px
  width 100%
  .v-exhibitor-header
    padding 0 12px
    .v-exhibitor-info
      flex: 1
      min-width 50%
      margin-left 12px
      .v-company-name
        display inline-block
        max-width 425px
        font-size 16px
        font-weight 700
        overflow: hidden
        text-overflow:ellipsis
        white-space: nowrap
      .v-follow-num
        display inline-block
        width 80px
        text-align right
        color $color-black-45
        font-size 14px
      .v-exhibitor-info3
        font-size 12px
        align-items flex-end
        .v-item
          margin 0 24px
        .v-collect>span
          font-size 14px
          margin-left 1px
          color $color-black-65
          &.iconfont
            color $color-main
    .img-box
      width 60px
      height 60px
  .v-exhibitor-body
    padding 8px 12px 0 12px
    .v-swiper-box
      margin 12px 0
      .img-box
        width 180px
        height 90px
    .theme-label
      margin-left 0
      margin-bottom: 8px;
    .v-tag-list
      height 68px
      overflow hidden
  .v-exhibitor-footer
    padding 0 12px
    height 44px
    background $color-gray-f5
    >div
      margin-left 25px
</style>
